<template>
  <div class="admin-header d-flex align-items-center">
    <div class="container-fluid d-flex align-items-center justify-content-between gap-3 flex-nowrap px-3 h-100">
      <!-- Left: Agency Selector -->
      <div class="d-flex align-items-center" style="min-width: 0;">
        <the-agency-selector/>
      </div>

      <!-- Right: Admin Menu and User Actions -->
      <div class="d-flex align-items-center gap-3">
        <the-admin-menu/>
        <div class="menu-divider mx-2"></div>
        <div class="d-flex align-items-center gap-3">
          <the-header-notification-dropdown v-if="!agency?.isCollaborator" />
          <the-header-user-dropdown/>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapState } from 'pinia';
import TheHeaderUserDropdown from '@/components/header/TheHeaderUserDropdown.vue';
import { useAuthStore } from '@/stores/auth';
import TheHeaderNotificationDropdown from '@/components/header/TheHeaderNotificationDropDown.vue';
import TheAdminMenu from '@/components/header/TheAdminMenu.vue';
import TheAgencySelector from '@/components/header/TheAgencySelector.vue';

export default defineComponent({
  name: 'TheAdminHeader',
  components: {
    TheAdminMenu,
    TheAgencySelector,
    TheHeaderUserDropdown,
    TheHeaderNotificationDropdown,
  },
  computed: {
    ...mapState(useAuthStore, ['user']),
    ...mapState(useAuthStore, ['agency']),
  },
});
</script>

<style lang="scss" scoped>
.admin-header {
  background-color: #f8f9fa;
  height: 40px;
  border-bottom: 1px solid #dee2e6;
}

.menu-divider {
  width: 1px;
  height: 20px;
  background-color: #dee2e6;
}
</style>
